import styled, { css } from 'styled-components';

type FlexContainerProps = {
  justifyContent?: string;
  alignItems?: string;
  flexWrap?: string;
  flexDirection?: string;
};

const justifyContentMixin = css<FlexContainerProps>`
  ${(props) =>
    props.justifyContent ? `justify-content: ${props.justifyContent}` : ''};
  ${(props) => (props.alignItems ? `align-items: ${props.alignItems}` : '')};
  ${(props) => (props.flexWrap ? `flex-wrap: ${props.flexWrap}` : '')};
`;

const alignItemsMixin = css<{ alignItems?: string }>`
  ${(props) => props.alignItems && `align-items: ${props.alignItems}};`}
`;
const flexDirectionMixin = css<{ flexDirection?: string }>`
  ${(props) =>
    props.flexDirection && `flex-direction: ${props.flexDirection}};`}
`;

export const FlexContainer = styled.div<FlexContainerProps>`
  display: flex;
  ${justifyContentMixin}
  ${alignItemsMixin}
  ${flexDirectionMixin}
`;

export const FlexBox = styled.div<{ flex: number }>`
  ${(props) => props.flex !== undefined && `flex: ${props.flex}`}
`;
